export default "__VITE_ASSET__Bd46hjPp__"